import {
  ArrowBack,
  DesktopMac,
  Email,
  PhoneAndroid,
} from '@mui/icons-material';
import { Alert, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Channel from './Channel';
import NotificationCenterTab from './NotificationCenterTab';

export default function ConfigurationTab({
  onClose,
  onGoBack,
  additionalConfiguration,
  channelsState,
  onChannelsStateChange,
  onOpenUpdateProfile,
  onOpenVerificationDialog,
  person,
}) {
  const { t } = useTranslation('global');
  const phoneMessage =
    (!person.phone && t('notifications.SMSTooltip')) ||
    t('notifications.verifyPhone');

  const phoneAction =
    (!person.phone && t('notifications.update')) ||
    t('phoneVerification.verify');

  const phoneCallback =
    (!person.phone && onOpenUpdateProfile) || onOpenVerificationDialog;

  const phoneHasIssue = !person.phone || !person.phoneVerifiedAt;
  return (
    <NotificationCenterTab
      header={
        <Stack flexGrow={1} alignItems="start">
          <Button onClick={onGoBack} startIcon={<ArrowBack />}>
            {t('notifications.back')}
          </Button>
        </Stack>
      }
      body={
        <Stack px={3} gap={4}>
          <Stack gap={1}>
            <Typography variant="h6">
              {t('notifications.settingsTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Trans t={t} i18nKey="notifications.settingsMessage" />
            </Typography>
            {phoneHasIssue && (
              <Alert
                severity="warning"
                sx={{
                  '& .MuiAlert-icon': {
                    alignItems: 'center',
                  },
                  '& .MuiAlert-action': {
                    padding: 0,
                    alignItems: 'center',
                  },
                }}
                action={
                  <Button color="inherit" onClick={phoneCallback}>
                    {phoneAction}
                  </Button>
                }
              >
                {phoneMessage}
              </Alert>
            )}
          </Stack>
          <Stack gap={1}>
            <Typography variant="subtitle2">
              {t('notifications.additionalChannelsTitle')}
            </Typography>
            <Stack direction="row" gap={3}>
              <Channel
                icon={<DesktopMac fontSize="large" />}
                name="System"
                active={channelsState.SYSTEM}
                onClick={() =>
                  onChannelsStateChange({
                    ...channelsState,
                    SYSTEM: !channelsState.SYSTEM,
                  })
                }
              />
              <Channel
                icon={<Email fontSize="large" />}
                name="Email"
                active={channelsState.EMAIL}
                onClick={() =>
                  onChannelsStateChange({
                    ...channelsState,
                    EMAIL: !channelsState.EMAIL,
                  })
                }
              />
              <Channel
                icon={<PhoneAndroid fontSize="large" />}
                name="SMS"
                active={channelsState.SMS}
                disabled={phoneHasIssue}
                tooltip={phoneHasIssue && phoneMessage}
                onClick={() =>
                  onChannelsStateChange({
                    ...channelsState,
                    SMS: !channelsState.SMS,
                  })
                }
              />
            </Stack>
          </Stack>
          <Stack pt={2}>{additionalConfiguration}</Stack>
        </Stack>
      }
      footer={<></>}
      onClose={onClose}
    />
  );
}
